<template>
	<div class="hR">
		<div class="hR-hnb">
			<HNB active="关于我们" single-title="部位推荐"></HNB>
		</div>
		<div class="hR-top">
			<div v-for="(item,index) in total" :key="index" class="hR-top-item" :class="{'active':currentindex==index}">
				<div @click="changeSvg(index)">

					<div class="svg-box">
						<div class="hR-svg">
							<div :class="[currentindex==index?'animated fadeInUp':'op-0']">
								<SvgIcon :svg-name="item.Enname" size="50"></SvgIcon>
							</div>
						</div>
						<div class="hR-item-name" :class="{'active':currentindex==index}">{{item.name}}</div>
					</div>
				</div>
				<div class="hR-line" v-show="index!=5">|</div>
			</div>

		</div>
		<!-- //产品展示中部 -->
		<div class="produce">
			<div class="produce-box" v-for="item in producttotal" v-show="currentcenterindex==item.cactive">
				<div class="left-img" style="position: relative;">
					<img class="amplification_1_1" :src="item.imgs" @click="to_station(item.cactive)">
					<SvgIcon :svg-name="item.svgName" size="60" style="position: absolute;left: 0%;top: -15%;"></SvgIcon>
				</div>
				<div class="center-total">
					<div class="center-box">
						<div class="center-li">
							<div class="centertitle">{{item.shopsTitle}}</div>
							<div class="ullibox">
								<div class="ulli" v-for="smallitem in item.leftList">{{smallitem.name}}
								</div>
							</div>
						</div>
						<div class="right-li">
							<div class="righttitle">{{item.halfTitle}}</div>
							<div class="ullibox1" style="margin-top: 1rem;">
							<!-- <ul> -->
								<div class="ul-li" v-for="(index,i) in item.shop" :key="i" :data-url="index.url" @click="go_path">{{index.name}}
							<!-- </ul> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>
		<!-- //产品展示图片 -->
		<div class="produce-img" v-show="currentindex==0">
			<div class="produce-box" :style="'width:'+poroductListWidth + 'px;'">
				<div v-for="(item,index) in Imgs1" :key="item.url" @click="changecenter(item.act)" class="produce-img-show">
					<img :src="item.url" alt="">
					<SvgIcon :svg-name="item.svgName" size="60" style="position: absolute;left: 0%;top: 0%;"></SvgIcon>
				</div>
			</div>
		</div>
		<div class="produce-img" v-show="currentindex==1">
			<div class="produce-box" :style="'width:'+poroductListWidth + 'px;'">
				<div v-for="(item,index) in Imgs2" :key="item.url" @click="changecenter(item.act)" class="produce-img-show">
					<img :src="item.url" alt="">
					<SvgIcon :svg-name="item.svgName" size="60" style="position: absolute;left: 0%;top: 0%;"></SvgIcon>
				</div>
			</div>
		</div>
		<div class="produce-img" v-show="currentindex==2">
			<div class="produce-box" :style="'width:'+poroductListWidth + 'px;'">
				<div v-for="(item,index) in Imgs3" :key="item.url" @click="changecenter(item.act)" class="produce-img-show">
					<img :src="item.url" alt="">
					<SvgIcon :svg-name="item.svgName" size="60" style="position: absolute;left: 0%;top: 0%;"></SvgIcon>
				</div>
			</div>
		</div>
		<div class="produce-img" v-show="currentindex==3">
			<div class="produce-box" :style="'width:'+poroductListWidth + 'px;'">
				<div v-for="(item,index) in Imgs4" :key="item.url" @click="changecenter(item.act)" class="produce-img-show">
					<img :src="item.url" alt="">
					<SvgIcon :svg-name="item.svgName" size="60" style="position: absolute;left: 0%;top: 0%;"></SvgIcon>
				</div>
			</div>
		</div>
		<div class="produce-img" v-show="currentindex==4">
			<div class="produce-box" :style="'width:'+poroductListWidth + 'px;'">
				<div v-for="(item,index) in Imgs5" :key="item.url" @click="changecenter(item.act)" class="produce-img-show">
					<img :src="item.url" alt="">
				</div>
			</div>
		</div>
		<div class="produce-img" v-show="currentindex==5">
			<div class="produce-box" :style="'width:'+poroductListWidth + 'px;'">
				<div v-for="(item,index) in Imgs6" :key="item.url" @click="changecenter(item.act)" class="produce-img-show">
					<img :src="item.url" alt="">
				</div>
			</div>
		</div>

		<p class="geo-last-updated">本文最后更新于：{{ '' | yearMonth }}</p>

		<BS :BsTitle="bsTitle"></BS>

		<PopUp v-if="popUp" @clickBac="clickBac" :sampleName="sampleName"></PopUp>

	</div>

</template>

<script>
	import HNB from '@/components/HeaderNavigationBar.vue'
	import BS from '@/components/bottomShow'
	import SvgIcon from '@/components/SvgIcon'
	import PopUp from '../components/LFPopUp.vue'

	export default {
		name: 'remommand',
		props: [

		],
		data() {
			return {
				popUp: false,
				total: [{
						name: '全身',
						path: '/body',
						Enname: 'body'
					},
					{
						name: '头部',
						path: '/head',
						Enname: 'head'
					},
					{
						name: '颈部',
						path: '/shoulder',
						Enname: 'shouder'
					},
					{
						name: '腰部',
						path: '/waist',
						Enname: 'waist'
					},
					{
						name: '腿部',
						path: '/leg',
						Enname: 'leg'
					},
					{
						name: '脚部',
						path: '/foot',
						Enname: 'foot'
					},
				],
				producttotal: [
					{
						leftList: [{
								name: '• 随身按摩'
							},
							{
								name: '• 手法多样'
							},
							{
								name: '• 一指操控'
							},
							{
								name: '• 小巧便捷'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/bear.png',
						shopsTitle: '乐范随身魔力按摩贴',
						halfTitle: '口袋里的魔法师',
						cactive: 'molitie',
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=557143757149',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/16993759952.html',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=718',
							}
						]
					},
					{
						
						leftList: [{
								name: '• 加热按摩'
							},
							{
								name: '• 20档力度'
							},
							{
								name: '• 智能双控'
							},
							{
								name: '• 便携收纳'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/warm.png',
						shopsTitle: '乐范魔力贴温情版',
						halfTitle: '有温度的口袋按摩师',
						cactive: 'warm',
						svgName:'',
						shop: [{
							name: '京东旗舰店',
							url: 'https://item.jd.com/70660829749.html',
						}]
					}, {
						leftList: [{
								name: '• 四驱多路按摩'
							},
							{
								name: '• 磁吸链接'
							},
							{
								name: '• App智能操控'
							},
							{
								name: '• 无线便携'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/siqu.png',
						shopsTitle: '乐范四驱魔力按摩贴 ',
						halfTitle: '更专业的随身按摩师',
						svgName:'',
						cactive: 'siqu',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=598748601388',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/66370655548.html',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=110007',
							}
						]
					},
					{
						
						leftList: [{
								name: '• 经络推拿'
							},
							{
								name: '• 穴位按摩'
							},
							{
								name: '• 全身可用'
							},
							{
								name: '• 小巧便携'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/zhua.png',
						shopsTitle: '乐范小摩爪按摩器',
						halfTitle: '按摩小物  轻巧随行',
						svgName:'',
						cactive: 'zhua',
						shop: [{
							name: '京东旗舰店',
							url: 'https://item.jd.com/44617830234.html',
						}]
					},
					{
						leftList: [{
								name: '• 仿真按摩'
							},
							{
								name: '• 揉捏机芯'
							},
							{
								name: '• 一键操控'
							},
							{
								name: '• 无线便携'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/egg.png',
						shopsTitle: '乐范小魔蛋趣味按摩仪',
						halfTitle: '养生与艺术  在掌心融合',
						svgName:'',
						cactive: 'egg',
						shop: [{
							name: '小米有品',
							url: 'https://www.xiaomiyoupin.com/detail?gid=109422',
						}]
					}, {
						leftList: [{
								name: '• 小爱语音交互'
							},
							{
								name: '• 3D揉捏肩颈'
							},
							{
								name: '• 超长贴身按摩'
							},
							{
								name: '• 零重力云端体验'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/chair.png',
						shopsTitle: '乐范一维AI智能按摩椅',
						halfTitle: '按摩  一句话的事儿',
						cactive: 'chair',
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=575892509298',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/44488975225.html',
							}
						]
					},

					{
						leftList: [{
								name: '• 电动升降'
							},
							{
								name: '• 预防颈椎病'
							},
							{
								name: '• App站姿管理'
							},
							{
								name: '• 15Kg动态承重'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/desk.png',
						shopsTitle: '乐班电动电脑升降台',
						halfTitle: '坐站办公  一键切换',
						cactive: 'desk',
						svgName:'upstytle',
						shop: [{
							name: '小米有品',
							url: 'https://www.xiaomiyoupin.com/detail?gid=104011',
						}]
					},
					{
						leftList: [{
								name: '• 三维立体护眼'
							},
							{
								name: '• 太阳穴按摩'
							},
							{
								name: '• 手势操控'
							},
							{
								name: '• 可拆卸清洗'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/eye.png',
						shopsTitle: '乐范灵眸眼部按摩仪',
						halfTitle: '能做“眼保健操”的护眼仪',
						cactive: 'lingmou',
						svgName:'goodDesign',
						shop: [{
							name: '天猫旗舰店',
							url: 'https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.7b773205rsioG5&id=617440666072'
						}, {
							name: '京东旗舰店',
							url: 'https://item.jd.com/69487789328.html'
						}, {
							name: '小米有品',
							url: 'https://www.xiaomiyoupin.com/detail?gid=119408'
						}]
					},
					{
						leftList: [{
								name: '• 冷热双感敷眼'
							},
							{
								name: '• 自动感应按摩'
							},
							{
								name: '• 一键式操作'
							},
							{
								name: '• 小巧便携'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/eyes.png',
						shopsTitle: '乐范眼部冷热按摩仪',
						halfTitle: '多效合一  宠爱你的双眼',
						cactive: 'coldhot', //coldhot
						svgName:'',
						shop: [{
							name: '天猫旗舰店',
							url: 'https://detail.tmall.com/item.htm?spm=a220m.1000858.0.0.44499a95ab672C&id=567550623777'
						}, {
							name: '京东旗舰店',
							url: 'https://item.jd.com/27690415184.html'
						}, {
							name: '小米有品',
							url: 'https://www.xiaomiyoupin.com/detail?gid=114220'
						}]
					},
					{
						leftList: [{
								name: '• 按摩解压'
							},
							{
								name: '• 放松入眠'
							},
							{
								name: '• 三点支撑'
							},
							{
								name: '• 收纳自如'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/neckpillow.png',
						shopsTitle: '乐范按摩助眠颈枕 ',
						halfTitle: '10分钟  按摩放松  清零压力',
						svgName:'',
						cactive: 'jingzhen', //jingzhen
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-15796244175.20.228757597YQIEi&id=562586207011'
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/68729122852.html'
							}, {
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=100636'
							}
						]
					},
					{
						leftList: [{
								name: '• 通孔透气'
							},
							{
								name: '• 双弹力海绵'
							},
							{
								name: '• 冰感面料'
							},
							{
								name: '• 免拆水洗'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/tanli.png',
						shopsTitle: '乐范双弹力透气U型枕 ',
						halfTitle: '双弹力  让支撑更舒适',
						svgName:'',
						cactive: 'uxingzhen1', //uxingzhen
						shop: [{
							name: '小米有品',
							url: 'https://www.xiaomiyoupin.com/detail?gid=118621'
						}]
					},
					{
						leftList: [{
								name: '• 3D按摩'
							},
							{
								name: '• PTC热敷'
							},
							{
								name: '• 无线便携'
							},
							{
								name: '• 强劲扭力'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/rounie.png',
						shopsTitle: '乐范揉捏按摩靠枕',
						halfTitle: '无线按摩  放松不受限',
						cactive: 'kaozhen', //kaozhen
						svgName:'IF',
						shop: [

							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/41309099542.html'
							}, {
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=117237'
							}
						]
					},
					// {
					// 	leftList: '<br>• 塑形挺背<br><br>• 保护腰椎<br><br>• 缓解身体疲劳<br><br>• 适合多种椅背',
					// 	imgs: this.GLOBAL.imgHost + '/images/suxing.png',
					// 	shopsTitle: '乐范塑形背靠',
					// 	halfTitle: '因为依靠  所以轻松',
					// 	cactive: 'suxing'
					// },
					// {
					// 	leftList: '<br>• 定点揉捏<br><br>• 游走推拿<br><br>• 贴合背部曲线<br><br>• 加热按摩',
					// 	imgs: this.GLOBAL.imgHost + '/images/yidian.png',
					// 	shopsTitle: '乐范背部按摩椅垫',
					// 	halfTitle: '简易“按摩椅”畅享全背放松',
					// 	cactive: 'yidian'
					// },
					{
						leftList: [{
								name: '• 环抱式承托'
							},
							{
								name: '• 一件升降'
							},
							{
								name: '• 扭簧设计'
							},
							{
								name: '• 久坐不累'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/beikao.png',
						shopsTitle: '乐班人体工学可调背靠',
						halfTitle: '科学塑形  舒适依靠',
						cactive: 'kaobei', //kaobei
						svgName:'IF',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=601814725936',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/55702917420.html',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=110050',
							}
						]
					},
					{
						leftList: [{
								name: '• 矫正坐姿'
							},
							{
								name: '• 护腰塑臀'
							},
							{
								name: '• 立体包裹'
							},
							{
								name: '• 形体支撑'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/zuodian.png',
						shopsTitle: '乐班护腰塑形坐垫',
						halfTitle: '你的私人坐姿矫正专家',
						cactive: 'zuodian',
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=587952281115',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/42422249527.html',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=105461',
							}
						]
					},
					{
						leftList: [{
								name: '• 气囊按摩'
							},
							{
								name: '• 塑造美腿'
							},
							{
								name: '• 小巧便携'
							},
							{
								name: '• 单双腿可选'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/lega.png',
						shopsTitle: '乐范无线按摩美腿仪',
						halfTitle: '让腿部塑形重归简单',
						cactive: 'meituiyi',
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=600594720741',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/44548256434.html',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=109539',
							}
						]
					},
					{
						leftList: [{
								name: '• 气囊按摩'
							},
							{
								name: '• 小巧便携'
							},
							{
								name: '• 紧密包裹'
							},
							{
								name: '• 三档可调'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/legb.png',
						shopsTitle: '乐范腿部气压按摩器 ',
						halfTitle: '让腿部塑形重归简单',
						cactive: 'qiyaleg', //qiyaleg
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=600594720741',
							},
							{
								name: '京东旗舰店',
								url: 'https://item.jd.com/44548256434.html',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=109539',
							}
						]
					},
					{
						leftList: [{
								name: '• 仿人手按摩'
							},
							{
								name: '• 揉捏推拿'
							},
							{
								name: '• 无线便携'
							},
							{
								name: '• 贴合颈部曲线'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/cappa.png',
						shopsTitle: '乐范3D揉捏按摩披肩  ',
						halfTitle: '无线设计  专为肩颈而生',
						cactive: 'cappa',
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=587716764745',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=104829',
							}
						]
					},
					{
						leftList: [{
								name: '• 仿真揉捏'
							},
							{
								name: '• 气压按摩'
							},
							{
								name: '• 热敷理疗'
							},
							{
								name: '• 透气设计'
							}
						],
						imgs: this.GLOBAL.imgHost + '/images/footmassager.png',
						shopsTitle: '乐范脚部揉捏按摩器 ',
						halfTitle: '雅趣养生  心满意足',
						cactive: 'foot',
						svgName:'',
						shop: [{
								name: '天猫旗舰店',
								url: 'https://detail.tmall.com/item.htm?id=578607134394',
							},
							{
								name: '小米有品',
								url: 'https://www.xiaomiyoupin.com/detail?gid=103324',
							}
						]
					},
					{
leftList: [{
        name: '• 人体工学设计'
       },
       {
        name: '• 撑肘立腰裹臀'
       },
       {
        name: '• EPS一体成型'
       },
       {
        name: '• 单手可拎'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/xiaoshafa800.png',
	  cactive: 'xiaoshafa',
	  svgName:'',
      shopsTitle: '乐班护腰阅读小沙发',
      halfTitle: '为你撑腰 舒适久坐',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RkClz4zJeMYpX4I?tk=zZ7Jg2ZI34n',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2RoCLo-z?jkl=@F8VqJ8chTk@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/B3Odixuh0P',
       }
      ]
	  },
	  {
leftList: [{
        name: '• 缓解身心压力'
       },
       {
        name: '• 快速专注冥想'
       },
       {
        name: '• 引导正确坐姿'
       },
       {
        name: '• 耐脏抗菌面料'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/zuodian800.png',
	  cactive: 'zuodian1',
	  svgName:'',
      shopsTitle: 'Zmind冥想坐垫',
      halfTitle: '一坐入静 专注冥想',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RkB9zU7G5GIbHdj?tk=q3P5g2bLwpc',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2R-oD5bp?jkl=@IDx7a4aHgZ@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://e.tb.cn/h.RkB9zU7G5GIbHdj?tk=q3P5g2bLwpc',
       }
      ]	 
	 },
	 {
	 leftList: [{
        name: '• 户外一拎即走'
       },
       {
        name: '• 磁吸折叠便携'
       },
       {
        name: '• 人体工学减压'
       },
       {
        name: '• 久坐回弹舒适'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/zhediezuodian800.png',
	  cactive: 'zhediezuodian',
	  svgName:'',
      shopsTitle: 'Zmind鹅卵石坐垫',
      halfTitle: '随时随地 冥想自由',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.R9pEsmOZDD8B9Lq?tk=IPnng2bMq3U',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2Ro-D0h8?jkl=@A47tTBDvqe@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/8e6KGxGF58B',
       }
      ]
	 },
	 {
leftList: [{
        name: '• 两翼环抱支撑'
       },
       {
        name: '• 颈部支撑'
       },
       {
        name: '• 气动调节'
       },
       {
        name: '• 一键旋钮切换'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/shuangqutou800.png',
	  cactive: 'shuangqutou',
	  svgName:'',
      shopsTitle: '乐班双区空气颈枕',
      halfTitle: '动态侧靠支撑 工位舒睡搭子',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.R9J8yzsLfk4GRRm?tk=GwrUg2cXvLv',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2RoD-MAR?jkl=@I8r9hD8mpa@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/5IyYVBoWF1E',
       }
      ]	 
	 },
	 {
leftList: [{
        name: '• 仿人手真揉捏'
       },
       {
        name: '• 放松全肩颈'
       },
       {
        name: '• 久戴不压肩'
       },
       {
        name: '• 创新双戴法'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/pijian800.png',
	  cactive: 'pijian',
	  svgName:'',
      shopsTitle: '乐范肩颈揉捏按摩仪 ',
      halfTitle: '拨筋开肩 告别紧绷',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RkAG7q8IiY3I7HA?tk=RjxNg21CBUU',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2-RoDhRR?jkl=@DA6gVCA38y@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/AcenBLljJX5',
       }
      ]	 
	 },
	 {
leftList: [{
        name: '• 仿生蝶形设计'
       },
       {
        name: '• 自适应追背承托'
       },
       {
        name: '• 适配身高调节'
       },
       {
        name: '• 双扭簧专利'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/beikao2-800.png',
	  cactive: 'beikao2',
	  svgName:'',
      shopsTitle: '乐班蝶形腰靠',
      halfTitle: '科学塑形 舒适依靠',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RkyzC7fscpBzl6z?tk=himcg2bdWC8',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2-RoDIsc?jkl=@SDD4oEnFRd@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/1qA8JURtKNO',
       }
      ]	 
	 },
	 {
leftList: [{
        name: '• 环抱式承托'
       },
       {
        name: '• 扭簧设计'
       },
       {
        name: '• 久坐不累'
       },
       {
        name: '• 一键升降'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/beikao1-800.png',
	  cactive: 'beikao1',
	  svgName:'',
      shopsTitle: '乐班人体工学可调腰靠 ',
      halfTitle: '科学塑形 舒适背靠',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RQFcC0OVWnBM9v1?tk=0Pjyg2ckJ1O',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2-RoDIsc?jkl=@SDD4oEnFRd@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/7XSOONj56DB',
       }
      ]	 
	 },
	 {
leftList: [{
        name: '• 腰部双呵护'
       },
       {
        name: '• 双层海绵'
       },
       {
        name: '• 创新按钮'
       },
       {
        name: '• 轻薄不占坐'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/shuangquyao800.png',
	  cactive: 'shuangquyao',
	  svgName:'',
      shopsTitle: '乐班双区空气靠垫 ',
      halfTitle: '5大创新优势 让坐/躺更舒服',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RQ0DBmKYGQUOOG3?tk=U3m0g2clFcL',
       },
       {
        name: '京东旗舰店',
        url: 'https://3.cn/2RoD-MAR?jkl=@I8r9hD8mpa@',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/4Wq5Uks0zc',
       }
      ]	 
	 },
	 {
leftList: [{
        name: '• EMS脉冲按摩'
       },
       {
        name: '• 暖宫热敷'
       },
       {
        name: '• 科学修复腹直肌'
       },
       {
        name: '• 改善体态腰围'
       }
      ],
      imgs: this.GLOBAL.imgHost + '/images/zhongpin800.png',
	  cactive: 'zhongpin',
	  svgName:'',
      shopsTitle: '乐范腰部训练仪 ',
      halfTitle: '真中频 更放松',
      shop: [{
        name: '天猫旗舰店',
        url: 'https://e.tb.cn/h.RkABoF3FKJ1UK3K?tk=iVCUg2cXZI8',
       },
       {
        name: '抖音旗舰店',
        url: 'https://v.douyin.com/HU8kcApUI1Q/',
       },
       {
        name: '小红书旗舰店',
        url: 'https://xhslink.com/m/Cel3weeRjI',
       }
      ]	 
	 }



				],
				rightList: ['天猫旗舰店', '抖音旗舰店', '小米有品','小红书旗舰店','京东旗舰店'],
				// shopsTitle: '乐范随身魔力按摩贴',
				// halfTitle: '口袋里的魔法师',
				Imgs1: [
					{
						url: this.GLOBAL.imgHost + '/images/xiaoshafa800.png',
						act: 'xiaoshafa',
						svgName:''
					},
					{
						url: this.GLOBAL.imgHost + '/images/zuodian800.png',
						act: 'zuodian1',
						svgName:''
					},
					{
						url: this.GLOBAL.imgHost + '/images/zhediezuodian800.png',
						act: 'zhediezuodian',
						svgName:''
					},
					{
						url: this.GLOBAL.imgHost + '/images/bear.png',
						act: 'molitie',
						svgName:''
					},					
					// {
					// 	url: this.GLOBAL.imgHost + '/images/warm.png',
					// 	act: 'warm',
					// 	svgName:''
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/siqu.png',
					// 	act: 'siqu',
					// 	svgName:''
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/zhua.png',
					// 	act: 'zhua',
					// 	svgName:''
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/egg.png',
					// 	act: 'egg',
					// 	svgName:''
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/chair.png',
					// 	act: 'chair',
					// 	svgName:''
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/desk.png',
					// 	act: 'desk',
					// 	svgName:'upstytle'
					// }
				],
				Imgs2: [
					{
						url: this.GLOBAL.imgHost + '/images/eye.png',
						act: 'lingmou',
						svgName:'goodDesign'
					},
					{
						url: this.GLOBAL.imgHost + '/images/eyes.png',
						act: 'coldhot',
						svgName:''
					}
				],
				Imgs3: [
					{
						url: this.GLOBAL.imgHost + '/images/shuangqutou800.png',
						act: 'shuangqutou',
						svgName:''						
					},
					{
						url: this.GLOBAL.imgHost + '/images/pijian800.png',
						act: 'pijian',
						svgName:''						
					},
					{
						url: this.GLOBAL.imgHost + '/images/neckpillow.png',
						act: 'jingzhen',
						svgName:''
					},
					{
						url: this.GLOBAL.imgHost + '/images/tanli.png',
						act: 'uxingzhen1',
						svgName:''
					}
				],
				Imgs4: [
					{
						url: this.GLOBAL.imgHost + '/images/beikao2-800.png',
						act: 'beikao2',
						svgName:'IF'
					},
					{
						url: this.GLOBAL.imgHost + '/images/beikao1-800.png',
						act: 'beikao1',
						svgName:'IF'
					},
					{
						url: this.GLOBAL.imgHost + '/images/shuangquyao800.png',
						act: 'shuangquyao',
						svgName:''
					},
					{
						url: this.GLOBAL.imgHost + '/images/zhongpin800.png',
						act: 'zhongpin',
						svgName:''
					},
					// {
					// 	url: this.GLOBAL.imgHost + '/images/suxing.png',
					// 	act: 'suxing'
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/yidian.png',
					// 	act: 'yidian'
					// },
					// {
					// 	url: this.GLOBAL.imgHost + '/images/beikao.png',
					// 	act: 'kaobei',
					// 	svgName:'IF'
					// },
					{
						url: this.GLOBAL.imgHost + '/images/zuodian.png',
						act: 'zuodian',
						svgName:''
					}
				],
				Imgs5: [{
						url: this.GLOBAL.imgHost + '/images/lega.png',
						act: 'meituiyi'
					},
					{
						url: this.GLOBAL.imgHost + '/images/legb.png',
						act: 'qiyaleg'
					}
				],
				Imgs6: [
					{
						url: this.GLOBAL.imgHost + '/images/footmassager.png',
						act: 'foot',
						svgName:''						
					},
				],
				isActive: false,
				isShow: false,
				isSvg: false,
				// imgs: this.GLOBAL.imgHost + '/images/recommand/MassageStick3.png',	
				currentindex: '',
				currentcenterindex: 'xiaoshafa',
				bsTitle: ['首页', '部位推荐']
			}
		},
		components: {
			HNB,
			BS,
			SvgIcon,
			PopUp,
		},
		computed: {
			poroductListWidth() {
				return (document.documentElement.clientWidth - 1024) / 2 + 1010;//1024会顶出横向滚动条 暂时改小一些
			}
		},
		methods: {
			go_path(e) {
				window.open(e.target.dataset.url, '_blank');
			},
			to_station(e) {
				if (e === '')
				document.body.style.overflow = 'hidden';
				this.sampleName = e;
				this.popUp = true;
			},
			clickBac() {
				this.popUp = false;
				document.body.style.overflow = 'auto';
			},
			changeSvg(index) {
				let that = this
				that.currentindex = index
				if (that.currentindex == 0) {
					that.currentcenterindex = 'xiaoshafa'
				}
				if (that.currentindex == 1) {
					that.currentcenterindex = 'lingmou'
				} else if (that.currentindex == 2) {
					that.currentcenterindex = 'shuangqutou'
				} else if (that.currentindex == 3) {
					that.currentcenterindex = 'beikao2'
				} else if (that.currentindex == 4) {
					that.currentcenterindex = 'meituiyi'
				} else if (that.currentindex == 5) {
					that.currentcenterindex = 'foot'
				}
			},
			changecenter(index) {
				this.currentcenterindex = index
			}

		}

	}
</script>

<!-- 中间模块 -->
<style>
	.produce {
		width: 100%;
		margin-top: 70px;
		background: rgba(249, 249, 249, 1);
		/* border: #000000 solid; */
	}

	.produce .produce-box {
		width: 100%;
		height: 31.2rem;
		display: flex;
		max-width: 1024px;
		margin: auto;
		overflow-y: hidden;
	}

	.produce .produce-box img {
		width: 100%;
		cursor: pointer;
	}

	.produce .center-total {
		margin-left: 7%;
		height: 500px;
	}

	.produce .left-img {
		margin-left: 5%;
		width: 30%;
		height: 30%;
		margin-top: 9%;
	}

	.produce .center-box {
		display: flex
	}

	.produce .center-li {
		width: 300px;

		margin-top: 100px;

	}

	.produce .center-li .centertitle {
		font-size: 22px;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		line-height: 51px;
		text-align: left;
	}

	.produce .center-li ul li {
		width: 84px;
		font-size: 20px;
		padding-left: 40px;
		font-weight: 250;
		color: rgba(24, 24, 24, 1);
		line-height: 45px;
		opacity: 0.7;
	}

	.produce .right-li {

		text-align: left;
		margin-top: 115px;
		padding-left: 70px;
	}

	.produce .right-li .righttitle {
		
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		text-align: left;

	}


	.produce .right-li .ul-li {
		height:4.2rem ;
		list-style-type: none;
		font-size: 16px;
		padding-inline-start: 0px;
		font-weight: 250;
		text-decoration: underline;
		color: rgba(24, 24, 24, 1);
		text-align: left;
		opacity: 0.7;
		line-height: 3.33rem;
		cursor: pointer;
	}

	.produce .produce-know {
		width: 173px;
		height: 27px;
		font-size: 18px;

		font-weight: 450;
		color: rgba(0, 199, 133, 1);
		line-height: 24px;
		padding-left: 25px;
		margin-top: 5%;
		padding-bottom: 5%;
		text-align: left;

	}

	.produce .right-li ul li {
		margin-right: 30px;
	}

	.produce .center-li ul {
		padding-inline-start: 50px;
	}
</style>
<!-- 下部 -->
<style>
	.ullibox {
		width: 8rem;
		height: 10rem;
		display: flex;
		flex-direction: column;
		justify-content:space-between;
		margin-top: 1.25rem;
	}

	.ulli {
		text-align: left;
		font-size: 16px;

		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		opacity: 0.7;
	
	}

	.produce-img {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		margin-bottom: 35px;
		margin-top: 10px;


	}

	.produce-img .produce-box {
		width: 85%;
		display: block;
		white-space: nowrap;
		overflow-x: auto;
		height: 300px;
		text-align: left;
	}

	/* .produce-box::-webkit-scrollbar { display: none; } */

	.produce-img .produce-img-show {
		width: 150px;
		height: 150px;
		padding: 50px;
		display: inline-block;
		background-color: #F4F4F4;
		margin-right: 10px;
		cursor: pointer;
		position: relative;
	}

	.produce-img .produce-img-show:hover {
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 16px 32px 0px rgba(41, 44, 51, 0.1);
	}

	.produce-img .produce-img-show img {
		width: 90%;
		display: block;
	}
</style>
<style scoped>
	.hR {
		width: 100%;


	}

	.hR-hvb {
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 25px 50px 0px rgba(41, 44, 51, 0.1);
		border-radius: 4px;
	}

	.hR .hR-top {

		max-width: 1024px;
		display: flex;

		justify-content: space-around;
		padding-top: 140px;
		margin: auto;
	}

	.hR .hR-top .hR-svg {
		width: 80px;
		height: 80px;
		padding: 10px;
		line-height: 145px;
		overflow: hidden;
	}

	.hR-item-name {
		width: 50%;
		margin: 0 auto;
		/* border: 1px solid #000088 !important; */
	}

	.hR-item-name.active {
		padding-bottom: 15px;
		border-bottom: 2px solid rgba(0, 199, 133, 1) !important;
	}

	.op-3 {
		opacity: 0.3;
	}

	.op-1 {
		opacity: 0.1;
	}

	.op-0 {
		opacity: 0;
	}

	.hR .hR-top .hR-svg .fadeInUp {
		opacity: 1;
	}

	.hR-top .hR-top-item {
		width: 100px;
		height: 100px;
		padding-bottom: 50px;
		cursor: pointer;
		display: flex;
	}

	.hR-top-item .svg-box {
		text-align: center;
		font-weight: 550;
	}

	.hR-line {
		margin-left: 35px;
		margin-top: 100px;
		width: 1px;
		height: 20px;
		color: rgba(0, 0, 0, 1);
		opacity: 0.8
	}

	.hR .active {
		/* border-bottom: 4px solid rgba(0, 199, 133, 1); */
		font-family: Alibaba-PuHuiTi-M;
	}

	.hR .hr-item-name {
		text-align: center;

	}
</style>
